import { useTranslation } from 'react-i18next';
import Modal from '../ui/Modal';

const OtherLinksModal = ({ open, onClose, links = [] }) => {
  const { t } = useTranslation(['layout']);

  return (
    <Modal open={open} onClose={onClose} title={t('footer.info')} maxWidth='md'>
      <div className='flex flex-col gap-2'>
        {links.length === 0 ? (
          <p className='text-gray-500 text-sm'>No hay enlaces disponibles</p>
        ) : (
          links.map((link) => (
            <a
              key={link.id}
              href={link.valor}
              target='_blank'
              rel='noreferrer'
              className='text-blue-600 hover:text-blue-800 hover:underline py-1 block'
            >
              {link.tipoEnlace?.descripcion || link.tipoEnlace?.nombre || 'Enlace'}
            </a>
          ))
        )}
      </div>
      <Modal.Actions>
        <button
          onClick={onClose}
          className='px-4 py-2 bg-gray-200 text-gray-800 rounded-md hover:bg-gray-300 transition-colors'
        >
          Cerrar
        </button>
      </Modal.Actions>
    </Modal>
  );
};

export default OtherLinksModal;

